export default __webpack_public_path__ + "static/media/paketmk-logo.5496af65.png";